import { createContext, useState, useContext } from 'react';
import { useSpring, animated } from '@react-spring/web';

export const UIContext = createContext();

export function UIProvider({ children }) {
  const [activeTab, setActiveTab] = useState('analyze');
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [celebrateLogin, setCelebrateLogin] = useState(false);
  const [creditAnimation, setCreditAnimation] = useState(false);

  // Spring animation for credit changes
  const creditSpring = useSpring({
    from: { transform: 'scale(1)' },
    to: { transform: creditAnimation ? 'scale(1.2)' : 'scale(1)' },
    config: { tension: 300, friction: 10 },
    onRest: () => setCreditAnimation(false)
  });

  // First login celebration
  const triggerCelebration = () => {
    setCelebrateLogin(true);
    setTimeout(() => setCelebrateLogin(false), 3000);
  };

  // Credit change animation
  const triggerCreditAnimation = () => {
    setCreditAnimation(true);
  };
  
	  // Add to UIContext.js
	const [uiAnimations, setUiAnimations] = useState({
	  holographicEffect: false,
	  creditPulse: false,
	  notificationPulse: false
	});

	const triggerHolographicEffect = (duration = 2000) => {
	  setUiAnimations(prev => ({...prev, holographicEffect: true}));
	  setTimeout(() => {
		setUiAnimations(prev => ({...prev, holographicEffect: false}));
	  }, duration);
	};

const triggerCreditPulse = () => {
  setUiAnimations({...uiAnimations, creditPulse: true});
  setTimeout(() => setUiAnimations({...uiAnimations, creditPulse: false}), 1000);
};


  return (
    <UIContext.Provider value={{
      activeTab,
      setActiveTab,
      showAuthModal,
      setShowAuthModal,
      celebrateLogin,
      triggerCelebration,
      creditSpring,
      triggerCreditAnimation,
	  uiAnimations,
      triggerHolographicEffect,
      triggerCreditPulse
    }}>
      {children}
    </UIContext.Provider>
  );
}

export const useUIContext = () => useContext(UIContext);